import { useState } from 'react';

import Text from '@cartwhl/ui/base/TextNew';

import {
  useAssetLibraryCompactLayout,
  useAssetLibraryEmbedConfig,
} from '../assetLibraryEmbedContext';
import {
  type AssetLibraryGroupDetailItem,
  type AssetLibraryGroupDetailSelection,
  formatGroupDetailItemTitle,
  toGroupDetailItemDisplayAsset,
} from '../assetLibraryGroupDetail';
import AssetLibraryCardShell from './AssetLibraryCardShell';
import AssetLibraryCardThumbnailShell from './AssetLibraryCardThumbnailShell';

export interface AssetLibraryGroupItemCardProps {
  item: AssetLibraryGroupDetailItem;
  index: number;
  groupSelection: Pick<
    AssetLibraryGroupDetailSelection,
    'groupID' | 'groupName' | 'assetType'
  >;
  onClick?: () => void;
}

export default function AssetLibraryGroupItemCard({
  item,
  index,
  groupSelection,
  onClick,
}: AssetLibraryGroupItemCardProps) {
  const embedConfig = useAssetLibraryEmbedConfig();
  const compact = useAssetLibraryCompactLayout();
  const autoPlayVideo =
    embedConfig == null ? true : (embedConfig.autoPlayThumbnails ?? false);
  const [isHovered, setIsHovered] = useState(false);
  const title = formatGroupDetailItemTitle(index, item.name);
  const isInteractive = Boolean(onClick);
  const displayAsset = toGroupDetailItemDisplayAsset(item, groupSelection);

  return (
    <AssetLibraryCardShell
      compact={compact}
      interactive={isInteractive}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <AssetLibraryCardThumbnailShell
        asset={displayAsset}
        embedded={Boolean(embedConfig)}
        isHovered={isHovered}
        autoPlayVideo={autoPlayVideo}
        isGroupDetailItem
        onClick={onClick}
        className="bg-tertiary relative aspect-video w-full shrink-0 overflow-hidden rounded-lg"
      />
      <Text
        token={compact ? { base: '12/medium', sm: '14/medium' } : '14/medium'}
        className="text-secondary truncate px-2"
        title={title}
      >
        {title}
      </Text>
    </AssetLibraryCardShell>
  );
}
